<template>
  <div class="footer-wrapper">
    <!-- 底部导航 -->
    <footer class="footer-pc" style="background:#F9FAFD;padding-bottom: 40px;">
      <section class="footer" style="width:100%">
        <ul>
          <li>
            <div>
              <div style="margin-right:14px">
                <img src="https://new-official.dev-01.54test.cn/Home/images/fanyalogo.png" style="width:113px;height:47px" />
              </div>
              <div style="font-size:16px;color:#333333;line-height:21px;height:21px;font-family:Microsoft YaHei;margin-top:6px">人力资源外包服务行业创新实践者</div>
            </div>
            <dl style="margin-top:20px">
              <dd>
                <img src="https://new-official.dev-01.54test.cn/Home/images/fanyali.png" />
                <b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;font-size: 14px;">
                  扫一扫添加<b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;">泛亚人力企业微信</b>
                </b>
              </dd>
              <dd>
                <img src="https://new-official.dev-01.54test.cn/Home/images/newweixingzh.jpeg" />
                <b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;font-size: 14px;">
                  扫一扫关注<b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;">泛亚人力公众号</b>
                </b>
              </dd>
            </dl>
          </li>
          <li>
            <div id="text-title">企业服务</div>
            <div style="display:flex">
              <div style="margin-right:40px">
                <span><a href="https://new-official.dev-01.54test.cn/yuangongpaiqian" target="_blank">员工派遣</a> </span>
                <span><a href="https://new-official.dev-01.54test.cn/laowuwaibao" target="_blank">劳务外包</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/yewuwaibao" target="_blank">业务外包</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/qishidaiban" target="_blank">企事代办</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/yunpeixun" target="_blank">云培训</a></span>
              </div>
              <div>
                <span><a href="https://new-official.dev-01.54test.cn/kaowuwaibao" target="_blank">考务外包</a> </span>
                <span><a href="https://new-official.dev-01.54test.cn/laodongfalv" target="_blank">劳动法律服务</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/yuangongtijian" target="_blank">员工体检</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/jiejiarifuli" target="_blank">节假日福利</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/jifenfuli" target="_blank">积分福利</a></span>
              </div>
            </div>
          </li>
          <li style="margin-left:60px">
            <div id="text-title">全球用工</div>
            <div style="display:flex">
              <div style="margin-right:40px">
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">名义雇主</a> </span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">跨境薪酬</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">灵活用工</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">全球招聘</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">工作签证</a></span>
              </div>
              <div>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">当地用工咨询</a> </span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">全球医疗</a></span>
                <span><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">跨境保险</a></span>
              </div>
            </div>
          </li>
          <li style="margin-left:60px">
            <div id="text-title">了解泛亚</div>
            <span>
              <a href="https://new-official.dev-01.54test.cn/AboutUs#gsjj" target="_blank">公司介绍</a> 
            </span>
            <span><a href="https://new-official.dev-01.54test.cn/Honor#zzrz" target="_blank">资质认证</a></span>
            <span><a href="https://new-official.dev-01.54test.cn/IndustryStudy" target="_blank">政策资讯</a></span>
          </li>
          <li style="margin-left:60px">
            <h3 id="text-title">联系方式</h3>
            <span class="footer_text1">服务热线：</span>
            <div style="font-family: Microsoft YaHei, Microsoft YaHei;margin-bottom:30px;font-weight: bold;font-size: 24px;color: #333333;font-style: normal;">
              400-623-9996
            </div>
            <span class="footer_text1">商务合作：fairhrmk@fairhr.com</span>
            <span class="footer_text1">投诉热线：0755-8250 4488-817</span>
            <span class="footer_text1">建议投诉：faircs@fanryes.com</span>
          </li>
        </ul>
        <div class="lianjie1">
          友情链接：<a href="http://www.fanryes.com" target="_blank">泛睿企服</a>
          <a href="https://www.1renshi.com/" target="_blank">第一人</a>
          <a href="https://wenku.1renshi.com/" target="_blank">HR文库</a>
        </div>
        <p style="display:flex;justify-content: space-between;">
          版权所有：深圳慧泽泛亚企业服务有限公司<a href="https://new-official.dev-01.54test.cn/sitemap.txt" target="_blank" style="color:#333333">网站地图</a>
          <a target="_blank" href="http://beian.miit.gov.cn/publish/query/indexFirst.action" style="display:inline-block;text-decoration:none;">粤ICP备12087401号-3</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402003878" style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
            <img src="https://new-official.dev-01.54test.cn/Home/images/baicon.png" style="float:left;margin-top: 4px" />
            <span style="height:30px;line-height:30px;margin: 0px 0px 0px 5px; color:#666666;">粤公网安备 44030402003878号</span>
          </a>
          <span style="display: inline-flex;align-items: center;justify-content: center;line-height: 20px;">
            Copyright 2004-{{ currentYear }} FairHR.Com All rights reserved.
            <span class="beianhao" ref="beianhaoPc"></span>
          </span>
        </p>
        <p>【免责声明】本站部分资讯信息为互联网收集而来，如内容侵犯了您的版权，请与我们联系，我们会及时做出处理，谢谢合作！</p>
      </section>
    </footer>

    <!-- 移动端footer -->
    <footer class="footer-mobile" style="background:#F9FAFD;padding-bottom: 40px;">
      <section class="footer">
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: flex-end; padding: 0 20px;">
          <div style="width:450px;">
            <h3 id="text-title" style="margin-bottom: 20px;">联系方式</h3>
            <div style="display: flex;">
              <span class="footer_text1">服务热线400-623-9996</span>
            </div>
            <div class="footer_text1">商务合作：fairhrmk@fairhr.com</div>
            <div class="footer_text1">投诉热线：0755-8250 4488-817</div>
            <span class="footer_text1">建议投诉：faircs@fanryes.com</span>
          </div>
          <div style="width: 85px; margin: 0 auto; display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
            <img src="https://new-official.dev-01.54test.cn/Home/images/fanyali.png" style="width: 50px; height: 50px;" />
            <b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;font-size: 8px; display: block; margin-top: 5px;width:85px">
              扫一扫添加泛亚人力企业微信
            </b>
          </div>
          <div style="width:75px;">
            <img src="https://new-official.dev-01.54test.cn/Home/images/newweixingzh.jpeg" style="width: 50px; height: 50px;" />
            <b style="text-align:center;font-family: Microsoft YaHei;font-weight: 400;font-size: 8px; display: block; margin-top: 5px;">
              扫一扫关注泛亚人力公众号
            </b>
          </div>
        </div>
        <div style="margin-top: 40px; padding: 0 20px;">
          <p style="display:flex; flex-direction: column; gap: 10px; margin-top: 20px;align-items: flex-start">
            <a target="_blank" href="http://beian.miit.gov.cn/publish/query/indexFirst.action" style="display:inline-block;text-decoration:none;padding: 0px!important;">粤ICP备12087401号-3</a>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402003878" style="padding: 0px!important;display:inline-block;text-decoration:none;height:30px;line-height:30px;">
              <img src="https://new-official.dev-01.54test.cn/Home/images/baicon.png" style="float:left;margin-top: 4px" />
              <span style="height:30px;line-height:30px;margin: 0px 0px 0px 5px; color:#666666;">粤公网安备 44030402003878号</span>
            </a>
            <span style="display: inline-flex; align-items: center; justify-content: left; line-height: 20px;">
              Copyright 2004-{{ currentYear }} FairHR.Com All rights reserved.
              <span class="beianhao" ref="beianhao"></span>
            </span>
            <span>版权所有：深圳慧泽泛亚企业服务有限公司<a href="https://new-official.dev-01.54test.cn/sitemap.txt" target="_blank" style="color:#333333">网站地图</a></span>
          </p>
        </div>
      </section>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    // 动态加载电子营业执照脚本
    const loadScript = (refName) => {
      if (this.$refs[refName]) {
        const script = document.createElement('script');
        script.id = 'ebsgovicon';
        script.src = 'https://szcert.ebs.org.cn/govicons.js?id=e9b9302e-0750-4e6f-92fb-8b0a1a81c304&width=20&height=20&type=2';
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        this.$refs[refName].appendChild(script);
      }
    };
    
    // 加载 PC 端和移动端的脚本
    loadScript('beianhaoPc');
    loadScript('beianhao');
  }
}
</script>

<style scoped>
.footer-wrapper {
  width: 100%;
}

.footer {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px 0;
}

.footer ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 40px;
}

.footer li {
  /* flex: 1;
  min-width: 200px;
  margin-right: 45px; */
}

.footer li:last-child {
  margin-right: 0;
}

.footer #text-title {
  color: #333333;
  font-size: 16px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  margin-bottom: 32px;
  line-height: 30px;
  height: 30px;
}

.footer_text1 {
  display: block;
  color: #333333;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  margin-bottom: 24px;
  line-height: 28px;
}

.footer li span {
  display: block;
  margin-bottom: 24px;
  line-height: 28px;
}

.footer li span a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.footer li span a:hover {
  color: #ff424f;
}

.footer dl {
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
  margin-right: 45px;
}

.footer dl dd {
  margin: 0;
  text-align: center;
  flex: 1;
}

.footer dl dd img {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  display: block;
}

.footer dl dd b {
  display: block;
  margin-top: 5px;
  color: #666;
}

.footer p {
  color: #666;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  margin: 10px 0;
}

.footer p a {
  color: #666;
  text-decoration: none;
}

.footer p a:hover {
  color: #ff424f;
}

.lianjie1 {
  margin-top: 32px;
  font-family: "Microsoft YaHei", sans-serif;
  text-align: center;
  color: #333;
  font-size: 14px;
}

.lianjie1 a {
  color: #333;
  text-decoration: none;
  margin: 0 10px;
  transition: color 0.3s;
}

.lianjie1 a:hover {
  color: #FF4150;
}

.beianhao {
  display: inline-block;
  margin-left: 10px;
}

.footer-mobile {
  display: none;
}

@media (max-width: 768px) {
  .footer-pc {
    display: none;
  }

  .footer-mobile {
    display: block;
  }

  .footer ul {
    flex-direction: column;
  }

  .footer li {
    /* margin-right: 0;
    margin-bottom: 30px; */
  }

  .footer li:last-child {
    margin-bottom: 0;
  }

  .footer dl {
    justify-content: center;
  }
}
</style>
